  import { error } from "toastr"
import {
  GET_ALERT_LOG_DETAILS,
  GET_ALERT_LOG_DETAILS_FAIL,
  GET_ALERT_LOG_DETAILS_SUCCESS,
  GET_ALERT_LOGS,
  GET_ALERT_LOGS_FAIL,
  GET_ALERT_LOGS_SUCCESS,
  POST_ACKNOWLEDGE_ALERT,
  POST_ACKNOWLEDGE_ALERT_FAIL,
  POST_ACKNOWLEDGE_ALERT_SUCCESS,
  POST_RESOLVE_ALERT,
  POST_RESOLVE_ALERT_FAIL,
  POST_RESOLVE_ALERT_SUCCESS,
  SELECT_ALERT_BY_ID,
  GET_ALERT_LOGS_COUNT,
  GET_ALERT_LOGS_COUNT_FAIL,
  GET_ALERT_LOGS_COUNT_SUCCESS,
  GET_RUNBOOK,
  GET_RUNBOOK_FAIL,
  GET_RUNBOOK_SUCCESS,
  POST_RUNBOOK_FEEDBACK,
  POST_RUNBOOK_FEEDBACK_FAIL,
  POST_RUNBOOK_FEEDBACK_SUCCESS,
  GET_RUNBOOK_FEEDBACKS,
  GET_RUNBOOK_FEEDBACKS_SUCCESS,
  GET_RUNBOOK_FEEDBACKS_FAIL,
  POST_RUNBOOK,
  POST_RUNBOOK_SUCCESS,
  POST_RUNBOOK_FAIL,
  UPDATE_RUNBOOK,
  UPDATE_RUNBOOK_SUCCESS,
  UPDATE_RUNBOOK_FAIL,
  GET_INTEGRATION_TYPES,
  GET_INTEGRATION_TYPES_FAIL,
  GET_INTEGRATION_TYPES_SUCCESS,
  GET_ALERT_CORRELATION,
  GET_ALERT_CORRELATION_SUCCESS,
  GET_ALERT_CORRELATION_FAIL,
  GET_ERROR_LOGS_SUCCESS,
  GET_ERROR_LOGS_FAIL,
  GET_RUNBOOK_RESULTS_ALERT_LOG_ID_SUCCESS,
  GET_RUNBOOK_RESULTS_ALERT_LOG_ID_FAIL,
  GET_RUNBOOK_RESULTS_ALERT_LOG_ID,
  GET_METRIC_DATA_BY_ALERT_LOG_ID_SUCCESS,
  GET_RUNBOOK_BY_RUNBOOK_ID_SUCCESS,
  GET_ALERT_LOG_STATUS_HISTORY_SUCCESS,
  GET_ALERT_LOG_STATUS_HISTORY_FAIL,
  START_AI_CONVERSATION_SUCCESS,
  START_AI_CONVERSATION_FAIL,
  UPDATE_AI_RESPONSE_CHUNK,
  SET_AI_STREAMING,
  CLEAR_AI_RESPONSE,
  GET_PAST_AI_CONVERSATION_SUCCESS,
  GET_AGENT_AVAILABILITY_FOR_ALERT_LOG_SUCCESS,
  GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID_SUCCESS, HANDLE_APPROVAL_MESSAGE, SEND_APPROVAL_DECISION,
} from "./actionTypes"

  const INIT_STATE = {
    alerts: [],
    alerts_log_count: {},
    alert: null,
    success: null,
    error: null,
    integration_types: [],
    alert_correlation_data: {},
    metrics_data_by_alert_log_id: {},
    alertStatusHistory: {
      status_history: [],
    },
    runbook:[],
    runbook_details:{},
    runbook_results_by_alert_log_id: {},
    error_logs_by_alert_log: {
      'NewRelic': [],
      'CloudTrail': [],
      'Sentry': [],
      'Loki': [],
      'Coralogix': [],
      'integrated_systems': {'NewRelic': false, 'CloudTrail': false, 'Sentry': false, "Loki": false, "Coralogix": false}
    },
    ai_response:'',
    isStreaming: false,
    past_ai_conversation: [],
    agent_availability:{
      render_agent_chat: false,
      agent_online: false,
    },
    user_executed_results_by_alert_log_id:[],
    approval_required: false,
    approval_message: '',
  }

  const AlertLog = (state = INIT_STATE, action) => {
    switch (action.type) {
      case SELECT_ALERT_BY_ID : {
        return {
        ...state,
        alerts: action.payload ?
         state.alerts.includes(action.payload) ? state.alerts.filter((id) => id !== action.payload) : [...state.alerts, action.payload]
        : [...state.alerts]
       }
      }

      case GET_RUNBOOK:{
        return {
          ...state,
          error: action.payload,
        }
      }

      case GET_RUNBOOK_SUCCESS:{
        return {
          ...state,
          runbook: action.payload,
        }
      }

      case GET_RUNBOOK_FAIL: {
        return {
          ...state,
          error: action.payload
        }
      }

      case GET_INTEGRATION_TYPES: {
        return{
          ...state,
          error: action.payload,
        }
      }

      case GET_INTEGRATION_TYPES_SUCCESS: {
        return{
          ...state,
          integration_types: action.payload,
        }
      }

      case GET_INTEGRATION_TYPES_FAIL: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case POST_RUNBOOK_FEEDBACK: {
        return{
          ...state,
          error:action.payload
        }
      }

      case POST_RUNBOOK_FEEDBACK_FAIL: {
        return{
          ...state,
          error:action.payload
        }
      }

      case POST_RUNBOOK_FEEDBACK_SUCCESS: {
        return{
          ...state,
          data: action.payload,
        }
      }

      case GET_RUNBOOK_FEEDBACKS_SUCCESS: {
        return{
          ...state,
          feedbacks: action.payload,
        }
      }

      case GET_RUNBOOK_FEEDBACKS: {
        return{
          ...state,
          error:action.payload
        }
      }

      case GET_RUNBOOK_FEEDBACKS_FAIL: {
        return{
          ...state,
          error:action.payload
        }
      }

      case POST_RUNBOOK: {
        return{
          ...state,
          error: action.payload
        }
      }

      case POST_RUNBOOK_SUCCESS: {
        return{
          ...state,
          data: action.payload
        }
      }

      case POST_RUNBOOK_FAIL: {
        return{
          ...state,
          error: action.payload
        }
      }

      case UPDATE_RUNBOOK: {
        return{
          ...state,
          error: action.payload
        }
      }

      case UPDATE_RUNBOOK_SUCCESS: {
        return{
          ...state,
          data: action.payload
        }
      }

      case UPDATE_RUNBOOK_FAIL: {
        return{
          ...state,
          error: action.payload
        }
      }

      case GET_ALERT_LOGS: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case GET_ALERT_LOGS_SUCCESS: {
        return {
          ...state,
          alerts: action.payload,
        }
      }

      case GET_ALERT_LOGS_FAIL: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case GET_ALERT_LOGS_COUNT: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case GET_ALERT_LOGS_COUNT_SUCCESS: {
        return {
          ...state,
          alerts_log_count: action.payload,
        }
      }

      case GET_ALERT_LOGS_COUNT_FAIL: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case POST_ACKNOWLEDGE_ALERT: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case POST_ACKNOWLEDGE_ALERT_SUCCESS: {
        // prev state of alerts
        const updatedAlerts = state.alerts.map((alert) => {
          // correspoding acknoledged alert based on id
          const acknowledgedAlert = action.payload.find((resolved) => resolved.id === alert.id);

          return acknowledgedAlert ? acknowledgedAlert : alert;
        });

        // handling single selected alert
        const updatedAlert = action.payload.find((resolved) => resolved.id === state.alert?.id)
            ? action.payload.find((resolved) => resolved.id === state.alert.id)
            : state.alert;

        return {
          ...state,
          alerts: updatedAlerts,
          alert: updatedAlert,
        };
      }

      case POST_RESOLVE_ALERT_SUCCESS: {
        const updatedAlerts = state.alerts.map((alert) => {
          const resolvedAlert = action.payload.find((resolved) => resolved.id === alert.id);
          return resolvedAlert ? resolvedAlert : alert;
        });

        const updatedAlert = action.payload.find((resolved) => resolved.id === state.alert?.id)
            ? action.payload.find((resolved) => resolved.id === state.alert.id)
            : state.alert;

        return {
          ...state,
          alerts: updatedAlerts,
          alert: updatedAlert,
        };
      }

      case POST_ACKNOWLEDGE_ALERT_FAIL: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case POST_RESOLVE_ALERT: {
        return {
          ...state,
          error: action.payload,
        }
      }


      case POST_RESOLVE_ALERT_FAIL: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case GET_ALERT_LOG_DETAILS: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case GET_ALERT_LOG_DETAILS_SUCCESS: {
        return {
          ...state,
          alert: action.payload,
        }
      }

      case GET_ALERT_LOG_DETAILS_FAIL: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case GET_ALERT_CORRELATION: {
        return {
          ...state,
          error: action.payload,
        }
      }

      case GET_ALERT_CORRELATION_SUCCESS: {
        return {
          ...state,
          alert_correlation_data: action.payload,
        }
      }

      case GET_ALERT_CORRELATION_FAIL: {
          return {
          ...state,
          error: action.payload,
          }
      }

      case GET_ERROR_LOGS_SUCCESS:{
        return {
          ...state,
          error_logs_by_alert_log: action.payload,
        }
      }

      case GET_ERROR_LOGS_FAIL:{
        return {
          ...state,
          error: action.payload,
        }
      }
      case GET_METRIC_DATA_BY_ALERT_LOG_ID_SUCCESS:{
        return {
          ...state,
          metrics_data_by_alert_log_id: action.payload,
        }
      }
      case GET_RUNBOOK_BY_RUNBOOK_ID_SUCCESS:{
        return {
          ...state,
          runbook_details: action.payload,
        }
      }

      case GET_RUNBOOK_RESULTS_ALERT_LOG_ID_SUCCESS:{
        return {
          ...state,
          runbook_results_by_alert_log_id: action.payload,
        }
      }

      case GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID_SUCCESS:{
        return {
          ...state,
          user_executed_results_by_alert_log_id: action.payload,
        }
      }

      case HANDLE_APPROVAL_MESSAGE:
        return {
          ...state,
          approval_required: true,
          approval_message: action.payload,
        };

      case GET_ALERT_LOG_STATUS_HISTORY_SUCCESS: {
        return {
          ...state,
          alertStatusHistory: action.payload,
        }
      }
      case GET_ALERT_LOG_STATUS_HISTORY_FAIL: {
        return {
          ...state,
          error: action.payload,
        }
      }

      // case START_AI_CONVERSATION_SUCCESS:{
      //   return {
      //     ...state,
      //     ai_response: action.payload,
      //   }
      // }
      case START_AI_CONVERSATION_SUCCESS:
        return {
          ...state,
          error: null
        };

      case START_AI_CONVERSATION_FAIL:
        return {
          ...state,
          ai_response: `Error: ${action.payload}`,
          error: action.payload
        };

      case UPDATE_AI_RESPONSE_CHUNK:
        return {
          ...state,
          ai_response: state.ai_response + action.payload
        };

      case SET_AI_STREAMING:
        return {
          ...state,
          isStreaming: action.payload
        };

      case CLEAR_AI_RESPONSE:
        return {
          ...state,
          ai_response: ''
        };

      case GET_PAST_AI_CONVERSATION_SUCCESS:
        return {
          ...state,
          past_ai_conversation: action.payload
        };

      case GET_AGENT_AVAILABILITY_FOR_ALERT_LOG_SUCCESS:
        return {
          ...state,
          agent_availability: {
            ...state.agent_availability,
            render_agent_chat: action.payload.render_agent_chat,
            agent_online: action.payload.agent_online
          }
        };

      case SEND_APPROVAL_DECISION:
        return {
          ...state,
          approval_required: false,
        };
      default:
        return state;
    }
  }
  export default AlertLog;